import $ from "jquery";
import CookieHelper from "../base/CookieHelper";

export default class cookieBanner {
    static init() {
        let cookie = CookieHelper.get('dismiss-cookie-banner');
        if (cookie !== "1") {
            this.build();
            this.bindEvents();
        }
    }

    static build() {
        $('body').append(
            eotwJSXFactory('div', {className: "cookie-notice js-cookie-notice"}, [
                eotwJSXFactory('div', {className: "container cookie-notice__container"}, [
                    eotwJSXFactory('div', {className: "cookie-notice__text"}, [
                        eotwJSXFactory('p', null, ["We use cookies to enhance website functionality and to monitor performance. ", eotwJSXFactory('a', {href: "/privacy-policy/"}, ["Find out more"])])
                    ]),
                    eotwJSXFactory('div', {className: "cookie-notice__button"}, [
                        eotwJSXFactory('button', {className: "btn btn--small js-dismiss-cookie-banner"}, ["Okay"])
                    ])
                ])
            ])
        );
    }

    static bindEvents() {
        $('.js-cookie-notice').on('click', '.js-dismiss-cookie-banner', function () {
            $('.js-cookie-notice').hide();
            CookieHelper.set('dismiss-cookie-banner', 1, 30);
        });
    }
}
